import { render, staticRenderFns } from "./brands-container.vue?vue&type=template&id=3bc06bd6&scoped=true&lang=pug"
import script from "./brands-container.js?vue&type=script&lang=js&external"
export * from "./brands-container.js?vue&type=script&lang=js&external"
import style0 from "./brands-container.vue?vue&type=style&index=0&id=3bc06bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc06bd6",
  null
  
)

export default component.exports